import React from 'react';
import { Quote } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: "Arun Janarthanan",
      title: "CavinKare Private Limited",
      text: "The endorsement deal with Akshay Kumar for Indica Hair Colour wouldn't have been possible without Centre Stage. They brought in-depth industry knowledge, strong relationships, and a hands-on approach that made all the difference. What impressed us most was their ability to balance professionalism with a warm, personal touch, ensuring the collaboration felt effortless.",
      logo: "CavinKare"
    },
    {
      name: "Ravi Shankar",
      title: "Chief Brand & Communication Officer at LifeCell International Pvt. Ltd",
      text: "Whenever I narrate or recollect the Aishwarya Rai enrolment story to anyone, I don't miss to mention about you to them. You are an integral part of this epic event.",
      logo: "LifeCell"
    },
    {
      name: "Rajiv Hingoo",
      title: "MD & COO – Jefferies India",
      text: "Centre stage is an absolute pleasure to work with. Their attention to detail and meticulous planning makes the coordination process straightforward and efficient. They have a great understanding of the industry and their passion for creating successful events shines through in every detail. Their team is dedicated and supportive, ensuring a positive experience for all partners involved. I highly recommend them for all types of events and sporting connects. Wishing them all the very best!",
      logo: "Jefferies"
    },
    {
      name: "Nitin Raghuvanshi",
      title: "Chief Operating Officer at Ajivasan Group",
      text: "We were introduced to the Centre Stage team regarding our flagship event - Ajivasan ACT. We thank the team for executing sponsorships from household names like Dabur and Everest from start to end, ensuring all deliverables were met on time. We look forward to working with them again in the future!",
      logo: "Ajivasan"
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-slate-900 via-gray-900 to-gray-800 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-r from-amber-400/5 to-orange-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-r from-purple-400/5 to-pink-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white">
            Trusted by
            <span className="block bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-500 bg-clip-text text-transparent">
              India's Leading Brands
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Don't just take our word for it. Hear from the industry leaders who've partnered with Centre Stage for their biggest moments.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="group relative">
              {/* Gradient Border */}
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 via-purple-500/20 to-pink-500/20 rounded-2xl blur-lg group-hover:blur-xl transition-all duration-300 opacity-0 group-hover:opacity-100"></div>
              
              {/* Card */}
              <div className="relative bg-gradient-to-br from-slate-800/80 to-gray-900/80 backdrop-blur-xl border border-gray-700/50 rounded-2xl p-8 h-full flex flex-col hover:border-gray-600/80 transition-all duration-300 group-hover:shadow-2xl">
                {/* Stars */}
                <div className="flex gap-1 mb-4 text-2xl">
                  {[...Array(5)].map((_, i) => (
                    <span key={i}>⭐</span>
                  ))}
                </div>

                {/* Quote Icon */}
                <Quote className="w-8 h-8 text-cyan-400/40 mb-4" />

                {/* Text */}
                <p className="text-gray-200 leading-relaxed flex-grow mb-6 text-sm md:text-base">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="pt-6 border-t border-gray-700/50">
                  <p className="font-bold text-white text-sm md:text-base">{testimonial.name}</p>
                  <p className="text-gray-400 text-xs md:text-sm">{testimonial.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-20 text-center">
          <div className="inline-block bg-gradient-to-r from-cyan-500/10 via-purple-500/10 to-pink-500/10 border border-cyan-500/20 rounded-full px-8 py-4">
            <p className="text-gray-300">
              <span className="text-white font-bold">30+</span> years of trusted partnerships with India's top brands and celebrities
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
